<div
  class="country-drop-down"
  #selectFlags
  [class.align-right]="align === 'right'"
  [class.align-left]="align === 'left'"
>
  <div class="selected-value" (click)="toggleListCountryFlags()">
    <img src="{{ selectedCountryFlagImg }}" alt="selectedCountryCode" />
    <span>{{ selectedCountryCode }}</span>
  </div>
  <ul class="list" *ngIf="isShowListCountryFlags">
    @for (item of countryList; track item.label) {
      <li (click)="changeSelectedCountryCode(item)">
        <img src="{{ item.flag }}" />
        {{ item.label }}
      </li>
    }
  </ul>
</div>
